import {Directive, ElementRef, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
    selector: '[ngxTrimInput]',
})
export class TrimInputDirective {
    constructor(private el: ElementRef<HTMLInputElement>, private control: NgControl) {}

    @HostListener('blur')
    onBlur() {
        const inputEl = this.el.nativeElement;
        const originalValue = inputEl.value;
        const trimmedValue = originalValue.trim();

        if (originalValue !== trimmedValue && this.control?.control) {
            this.control.control.setValue(trimmedValue);
        }
    }
}
